@if (mode() === "ADD" || mode() === "RENAME") {
	<div class="text">
		<ng-content></ng-content>
		@if (!entry.secondLineTranslate) {
			<span class="h6">{{ entry.secondLine }}</span>
		}
		@if (entry.secondLineTranslate) {
			<span class="h6" translate="{{ entry.secondLineTranslate }}"></span>
		}
	</div>
}
@if (!(mode() === "ADD" || mode() === "RENAME")) {
	<div class="text">
		@if (entry.labelTranslate) {
			<span class="h3" [ngClass]="entry.labelClasses" [translate]="entry.labelTranslate"></span>
		}
		@if (!entry.labelTranslate) {
			<span class="h3" [ngClass]="entry.labelClasses">{{ entry.label }}</span>
		}
		@if (!entry.secondLineTranslate) {
			<span class="h6">{{ entry.secondLine }}</span>
		}
		@if (entry.secondLineTranslate) {
			<span class="h6" translate="{{ entry.secondLineTranslate }}"></span>
		}
	</div>
	<ng-container />
}
